import type { SaleDetailsDto } from "../../../api";

/**
 * The sale's ship-to when it's one of the buyer's saved delivery addresses,
 * else `null`. A quotation created without one (e.g. "Request quotation")
 * has Odoo's fallback — the buyer's company partner — which the BE won't
 * take payment for.
 */
export function getSaleDeliveryAddressId(sale: SaleDetailsDto | undefined): number | null {
  const shipId = sale?.shippingPartner?.id ?? null;
  return shipId != null && shipId !== sale?.partner?.id ? shipId : null;
}
